const ctr = {
    state: {
        targetData: {}
    },
    mutations: {
        SET_TARGET_DATA: (state, targetdata) => {
            state.targetData = targetdata
        },
        REMOVE_TARGET_DATA: (state, targetdata) => {
            state.targetData = ''
        }
    },
    actions: {
        setTargetJson({ commit }, newJson) {
            // console.log('setTargetJson')
            commit('SET_TARGET_DATA', newJson)
        },
        removeTargetJson({ commit }, newJson) {
            // console.log('removeTargetJson')
            commit('REMOVE_TARGET_DATA', '')
        }
    }
}

export default ctr